







import { Component, Vue } from 'vue-property-decorator';

import { ResponseCodeEnum, DeliveryDateModel, TireStoringContract } from '@/models';

import PickUpCalendar from '@/components/pickup/PickupCalendar.vue';


@Component({
    components: {
      PickUpCalendar,
    },
})
export default class PickUpCalendarPage extends Vue {

}
